/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { themes, fonts } from '../../themes/themes';
import CustomCircleProfilePic from '../CustomCircleProfilePic';
import './InnerBarPersonalDetails.css';
import EmployeeFullName from '../EmployeeFullName';
import EmployeeDesignation from '../EmployeeDesignation';
import { useNavigate } from 'react-router-dom';

import * as _ from 'lodash';
import CustomSwitch from '../CustomSwitch/CustomSwitch';
import Loader from '../../Lottifiers/Loader/Loader';
import { useAppSelector } from '../../../infra/hooks';
import { check_user_permission } from '../../configs/utils';

interface empDetailProps {
  employeeDetail: {
    name: string;
    designation: string;
    profilePic: any;
    award?: any;
  };
  emp_status?: boolean;
  callBackEmpStatus?: any;
  status_laoder?: boolean;
  trans?: any;
  ChecktheStatus?: any;
}

const InnerBarPersonalDetailsPresenter: React.FC<empDetailProps> = ({
  employeeDetail,
  emp_status,
  callBackEmpStatus,
  status_laoder,
  trans,
  ChecktheStatus,
}) => {
  const [, setSelectedLink] = useState('');
  const navigate = useNavigate();
  const [empStatus, setEmpStatus] = useState<any>();
  const company_id = useAppSelector((state) => state.authSlice.company_id);
  useEffect(() => {
    if (emp_status == true) {
      setEmpStatus(true);
    } else if (emp_status == false) {
      setEmpStatus(false);
    }
  }, [emp_status]);

  useEffect(() => {
    if (window.location.pathname == '/employeePersonalDetails') {
      ChecktheStatus(true);
    }
  }, []);
  const isExceptionEnabled = useAppSelector((state) => state.exception.isEnabled);

  useEffect(() => {
    const scroll_y: any = sessionStorage.getItem(window.location.pathname) ?? 0;
    window.scroll(0, scroll_y);
  });

  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );
  const configMenuList = useAppSelector(
    (state: any) => state.sideMenuSlice?.conigMenu,
  );

  const navigation_links = [
    { name: 'Personal Details', path: '/employeePersonalDetails' },
    /* { name: 'Warning & Complaint', path: '/WarningComplaint' }, */
    { name: 'Salary', path: '/employeeSalary' },
    { name: 'Leaves', path: '/employeeLeaves' },
    { name: 'Shift & Schedule', path: '/employeeShiftAndSchedule' },
    { name: 'Attendance', path: '/employeeAttendance' },
    { name: 'My Claims', path: '/employeeClaims' },
    { name: 'Recurring Payment', path: '/employeeRecurringPayments' },
    { name: 'Documents', path: '/employeeDocuments' },
    { name: 'Assets', path: '/employeeAssets' },
    { name: 'Insurance', path: '/employeeInsurance' },
    { name: 'Compalaints', path: '/employeeComplaints' },
    { name: 'Off-Boarding', path: '/employeeOffBoarding' },
    { name: 'Dependents', path: '/employeeDependents' },
    { name: 'Training', path: '/employeeTraining' },
    { name: 'Letter Generation', path: '/employeeLetterGeneration' },
    { name: 'performance', path: '/perfomance' },
    { name: 'Digital Signature Docs', path: '/digitalSignatureDocs' },
  ];

  if (isExceptionEnabled) navigation_links.push({ name: 'Attendance Exceptions', path: '/attendanceException' });
  const dynamicMenuNames = configMenuList.map((menu: any) => menu.name);
  const filtered_navigation_links = navigation_links.filter((link) => {
    return !dynamicMenuNames.includes(link.name);
  });

  const handleEmployeeStatus = () => {
    callBackEmpStatus(!empStatus);
    //setEmpStatus(!empStatus);
  };

  const is_FilePathset = useAppSelector(
    (state) => state.profilePicSlice.is_FilePathset,
  );

  const appIsUnderMaintenance =
    process.env.REACT_APP_UNDER_MAINTENANCE === 'true' ? true : false;

  if (appIsUnderMaintenance) {
    return null;
  }

  return (
    <Box className="wrapper-bar_personalDetails">
      <Grid item xs={12} className="profile-pic-box">
        {!is_FilePathset && (
          <CustomCircleProfilePic
            profilePic={{
              pic: employeeDetail.profilePic,
              award: employeeDetail.award,
            }}
          />
        )}
      </Grid>

      <Grid item xs={12} className="name-box">
        <EmployeeFullName first_name={employeeDetail?.name} last_name="" />
      </Grid>
      <Grid item xs={12} className="designation-box">
        <EmployeeDesignation designation={employeeDetail?.designation} />
      </Grid>
      {hr_view && (
        <Grid
          item
          xs={12}
          style={{
            marginTop: '2em',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#FAFAFA',
            padding: '8px',
            borderRadius: '10px',
            width: '100%',
          }}
        >
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              color: themes.tileKey_grey,
              cursor: 'default',
              marginRight: '0.5em',
            }}
          >
            {trans('Availability')}
          </Typography>
          <CustomSwitch
            checker={empStatus}
            onChange={() => handleEmployeeStatus()}
            label={empStatus ? trans('Active') : trans('InActive')}
          />
          {status_laoder && (
            <div
              style={{
                zIndex: '1',
                position: 'absolute',

                marginLeft: '8em',
              }}
            >
              <Loader height={100} width={200} />
            </div>
          )}
        </Grid>
      )}
      <Box style={{ marginTop: '1em' }} />
      <Grid item xs={12}>
        <Box
          className={
            window.location.pathname == '/employeePersonalDetails' && hr_view
              ? 'navigation-lists'
              : 'list_without_availaibility'
          }
        >
          {_.map(
            check_user_permission(
              auth_permissions,
              filtered_navigation_links,
              'main_menu',
            ),
            (link: { name: string; path: string }) => {
              return (
                <Box
                  onClick={() => {
                    setSelectedLink(link?.name);
                    navigate({ pathname: link.path });
                    window.history.scrollRestoration = 'auto';
                  }}
                  className={
                    window.location.pathname == link.path
                      ? 'selected-link'
                      : 'navigation-box'
                  }
                >
                  <Typography
                    style={{
                      fontSize: fonts.title,
                      fontFamily: fonts.fontFamily,
                      textWrap: 'nowrap',
                    }}
                  >
                    {trans(link.name)}
                  </Typography>
                </Box>
              );
            },
          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default InnerBarPersonalDetailsPresenter;
